export enum SAWGPMarketType {
	TwoTeamsWithScore = 1,
	RedCard = 2,
	OneXTwo = 3,
	OneXTwoHalftime = 4,
	// HalftimeFulltime = 5,
	FirstGoal = 6,
	DoubleChance = 7,
	OverUnder2_5 = 8,
	OverUnder1_5Halftime = 9,
	OverUnder1_5__2ndHalf = 10,
	TotalCorners8_5 = 11,
	TotalCorners9_5 = 12,
	Corners1x2 = 13,
	One_Two = 14,
	Overtime = 15,
	OddEven = 16,
	OddEvenHomeAway = 17,
	FirstSet = 18,
	SecondSet = 19,
	ThirdSet = 20,
	FourthSet = 21,
	FifthSet = 22,
	PlayerOneWinsOneSet = 23,
	PlayerTwoWinsOneSet = 24,
	LastGoal = 25,

	CustomSport = 26,
	CustomNonSport = 27,
}
